<template>
    <div class="weeklyTarget-wrapper wtpol-page">
        <div class="d-flex justify-content-center align-items-center weeklyTarget-header text-center">
            <span class="backArrowIcon" id="close" @click="goBack('someStatus')">
                <img :src="downArrow" alt="Back Arrow" />
            </span>
            <h2 class="m-0">Rules &amp; Regulations</h2>
        </div>

        <div class="wtpol-inner">

            <!-- Language switch -->
            <div class="wtpol-seg">
                <button type="button" :class="{ 'is-on': activeTab === 'language1Tab' }"
                    @click="activateTab('language1Tab')">Hinglish</button>
                <button type="button" :class="{ 'is-on': activeTab === 'language2Tab' }"
                    @click="activateTab('language2Tab')">English</button>
            </div>

            <!-- General streaming -->
            <section class="wtpol-card">
                <div class="wtpol-cardHd">
                    <span class="wtpol-icon">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#F2820D" stroke-width="2.1"
                            stroke-linecap="round" stroke-linejoin="round">
                            <circle cx="12" cy="12" r="9" />
                            <path d="M12 7v5.2l3.2 1.9" />
                        </svg>
                    </span>
                    <h3>{{ copy.generalTitle }}</h3>
                </div>
                <ul class="wtpol-list">
                    <li v-for="(rule, i) in copy.general" :key="i" v-html="rule"></li>
                </ul>
            </section>

            <!-- Reward ladder — the reason the page exists, so it leads visually -->
            <section class="wtpol-card">
                <div class="wtpol-cardHd">
                    <span class="wtpol-icon is-green">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#2E9E57" stroke-width="2.1"
                            stroke-linecap="round" stroke-linejoin="round">
                            <path d="M4 18V10" />
                            <path d="M10 18V6" />
                            <path d="M16 18v-5" />
                            <path d="M20 18H3.5" />
                        </svg>
                    </span>
                    <h3>{{ copy.ladderTitle }}</h3>
                </div>

                <div class="wtpol-ladderHead">
                    <span>{{ copy.ladderTarget }}</span>
                    <span>{{ copy.ladderReward }}</span>
                </div>
                <div class="wtpol-ladder">
                    <div v-for="tier in tiers" :key="tier.target" class="wtpol-tier">
                        <span class="wtpol-tierTarget wtpol-num">{{ tier.target }}</span>
                        <span class="wtpol-tierLead"></span>
                        <span class="wtpol-tierReward wtpol-num">
                            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                <circle cx="12" cy="12" r="9.5" fill="#F7C948" />
                                <circle cx="12" cy="12" r="6.4" fill="none" stroke="#E0A21B" stroke-width="1.5" />
                            </svg>
                            {{ tier.reward }}
                        </span>
                    </div>
                </div>
            </section>

            <!-- What counts towards the target -->
            <section class="wtpol-noteCard">
                <div class="wtpol-cardHd">
                    <span class="wtpol-icon">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#B9860B" stroke-width="2.1"
                            stroke-linecap="round" stroke-linejoin="round">
                            <circle cx="12" cy="12" r="9" />
                            <path d="M12 11v5.2" />
                            <path d="M12 7.6h.01" />
                        </svg>
                    </span>
                    <h3>{{ copy.noteTitle }}</h3>
                </div>
                <ul class="wtpol-list">
                    <li v-for="(note, i) in copy.notes" :key="i" v-html="note"></li>
                </ul>
            </section>

            <!-- Guidelines -->
            <section class="wtpol-card">
                <div class="wtpol-cardHd">
                    <span class="wtpol-icon is-blue">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#2F6FE4" stroke-width="2.1"
                            stroke-linecap="round" stroke-linejoin="round">
                            <path d="M3.5 6.5h13v11h-13z" />
                            <path d="M16.5 11l4-2.5v7l-4-2.5z" />
                        </svg>
                    </span>
                    <h3>{{ copy.guidelinesTitle }}</h3>
                </div>
                <ol class="wtpol-steps">
                    <li v-for="(guide, i) in copy.guidelines" :key="i">{{ guide }}</li>
                </ol>
            </section>

        </div>
    </div>
</template>

<script>
import downArrow from '../../assets/images/back-blackArrow.svg';
import './WeeklyTargetPolicyStyle.css';

// Same figures the old table carried, kept in one place so the two language
// tabs cannot drift apart.
const TIERS = [
    { target: '100K', reward: '40K' },
    { target: '250K', reward: '75K' },
    { target: '500K', reward: '125K' },
    { target: '1M', reward: '250K' },
    { target: '2.5M', reward: '625K' },
    { target: '5M', reward: '1.25M' },
];

const COPY = {
    language1Tab: {
        generalTitle: 'General Streaming',
        general: [
            'Streaming 24/7 available hai.',
            'Hosts ko roz maximum <b>5 hrs</b> stream aur calls milakar count hoga.',
            'Rewards ke liye, har week (Monday se Sunday) total <b>18 hrs</b> ka live streaming karna zaroori hai.',
        ],
        ladderTitle: 'Earn According to Target',
        ladderTarget: 'Target',
        ladderReward: 'Reward',
        noteTitle: 'Note',
        notes: [
            'For targets <b>up to 500K</b>, Call Earnings + Gifts + Game Tips — <b>all count</b> towards your reward.',
            'For <b>1M and above</b>, only <b>Gifts &amp; Game</b> Tips will be counted.',
        ],
        guidelinesTitle: 'Livestreaming Guidelines',
        guidelines: [
            'Apka background saaf-suthra aur organized hona chahiye. Professional look ke liye ek solid ya visually appealing background color use karein.',
            'Clear audio ke liye Bluetooth devices ka use karein aur visual effects ko enhance karne ke liye ring light lagayen.',
            'Smart casuals pehniye taaki aapki appearance polished aur professional lage.',
        ],
    },

    language2Tab: {
        generalTitle: 'General Streaming',
        general: [
            'Streaming is available 24/7.',
            'Hosts must stream and engage in calls for a maximum of <b>5 hours</b> daily.',
            'To qualify for rewards, a total of <b>18 hours</b> of live streaming must be completed weekly (Monday to Sunday).',
        ],
        ladderTitle: 'Earn According to Target',
        ladderTarget: 'Target',
        ladderReward: 'Reward',
        noteTitle: 'Note',
        notes: [
            'For targets <b>up to 500K</b>, Call Earnings + Gifts + Game Tips — <b>all count</b> towards your reward.',
            'For <b>1M and above</b>, only <b>Gifts &amp; Game</b> Tips will be counted.',
        ],
        guidelinesTitle: 'Livestreaming Guidelines',
        guidelines: [
            'Ensure your background is tidy and well-organized. Consider using a solid or visually appealing background color for a professional look.',
            'Use Bluetooth devices for clear audio quality and a ring light to enhance visual effects and presentation.',
            'Dress in smart casual attire to maintain a polished and professional appearance.',
        ],
    },
};

export default {
    name: 'WeeklyTargetPolicy',
    data() {
        return {
            activeTab: 'language1Tab',
            downArrow,
            tiers: TIERS,
        };
    },

    computed: {
        copy() {
            return COPY[this.activeTab] || COPY.language1Tab;
        },
    },

    methods: {
        activateTab(tabId) {
            this.activeTab = tabId;
        },
        handleTabChange(tabId) {
            this.activeTab = tabId;
        },

        // Close Webview on back arrow click
        goBack() {
            this.$router.go(-1);
        },
    },
};
</script>
